module.exports = __webpack_public_path__ + "static/payment1-8f3e175ffd644e4e76f082f9a92536fa.png";